<template>
  <div class="footer-nav-item-container">
    <nav>
      <ul
        v-if="menu"
        class="footer-nav-container">
        <template
          v-for="item in menu.menuItems.nodes"
          :key="item.id">
          <li :class="item.cssClasses.toString()">
            <quick-link
              :to="item.uri"
              :title="item.label">
              {{ item.label }}
            </quick-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from '@/stores/main'

const store = useStore()
const props = defineProps(['name'])
const menu = ref(store.menu({ name: props.name }))
</script>

<style lang="scss">
.footer-nav-container {
  @apply flex flex-col;

  li {
    @apply m-0 border-b flex border-b-capstan-lavender;

    a {
      @apply header-6 text-capstan-lavender py-2 m-0 w-full relative;

      &:after {
        @apply content-[''] hidden lg:block absolute pointer-events-none duration-300 transition-opacity opacity-0 -left-6 top-[calc(50%_-_5px)] rounded-full w-sm h-sm bg-capstan-lavender;
      }

      &:before {
        @apply opacity-0 w-0 h-0;
      }

      &.router-link-exact-active,
      &:hover {
        &:after {
          @apply opacity-100;
        }

        &:before {
          @apply opacity-0 w-0 h-0;
        }
      }
    }
  }
}
</style>
